export default "__VITE_ASSET__56d699fb__"